import React, { memo, useEffect } from 'react';
import { Stack, Divider, Typography } from 'investira.react.components';
import PlanoPosicao from '../PlanoPosicao';
import Highlights from './Highlights';
import Secoes from './Secoes';
import Graphs from './Graphs';
import ConsultaProvider from '../../../../contexts/ConsultaContext';
import useKickBack from '../../../../hooks/useKickBack';
import withMessage from '../../../../hoc/withMessage';

const ConsultaEnquadramento = memo(props => {
  const { data } = props;
  const kick = useKickBack();

  useEffect(() => {
    kick && props.onMessage('Entidade alterada');
  }, [kick]);

  return (
    <ConsultaProvider>
      <Stack spacing={2}>
        <PlanoPosicao
          beta={false}
          created={data.request?.data}
          carteira={data.request_metadata?.carteira || data.request_metadata?.portfolio}
          enquadramento={data.request_metadata?.enquadramento}
          consolidacao={data.request_metadata?.consolidacao}
          consolidacao_por_emissor={data.request.consolidacao_por_emissor}
          registrador={data.request_metadata?.username}
        />
        <Divider />
        <Stack sx={{ gap: 2 }} component="section" direction={{ xs: 'column', md: 'row' }}>
          <Stack
            sx={{
              flex: { xs: 1, md: 3, xl: 2 },
              minHeight: 0
            }}>
            <Highlights data={data} />
          </Stack>
          <Stack
            sx={{
              flex: { xs: 1, md: 5, xl: 5 },
              minHeight: 0
            }}>
            <Graphs data={data} />
          </Stack>
        </Stack>
        <Secoes data={data} />
        <Stack>
          <Typography variant="caption" color="textPrimary">
            <b>Métrica de Desenquadramento Relacionado ao Alvo:</b> esta métrica avalia o desempenho
            com base na proximidade em relação a um valor alvo estabelecido. Para um alvo definido
            de 5%, a faixa de tolerância para se considerar enquadrado permite uma variação de ±5%
            em relação a este alvo, criando uma margem de tolerância total de 10%. Consequentemente,
            a zona aceitável para enquadramento nesta métrica situa-se entre 0% e 10%, sendo a faixa
            ideal (o alvo propriamente dito) entre 4,5% e 5,5%.
          </Typography>
        </Stack>
      </Stack>
    </ConsultaProvider>
  );
});

export default withMessage(ConsultaEnquadramento);
